define( [
	"./arr"
], function( arr ) {
	"use strict";

	return arr.concat;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/concat.js
// module id = ewb2
// module chunks = 0 1